import { render } from "./wmsos-saida-list-nova.vue?vue&type=template&id=4a6e1599"
import script from "./wmsos-saida-list-nova.vue?vue&type=script&lang=js"
export * from "./wmsos-saida-list-nova.vue?vue&type=script&lang=js"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__